var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messages)?_c('span',{staticClass:"LabelFunMessage",domProps:{"innerHTML":_vm._s(_vm.getLabel(_vm.fcontId,_vm.msgkey))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }